import axios from "axios";
import React, { useEffect, useState } from "react";
import Collapsible from "react-collapsible";
import { Config } from "../../../../../Config";
import SearchSelect from "../Shared/SearchSelect";
import LineChart from "./Components/LineChart";

const PredictDashboard = (props) => {
  const [SkillChipIds] = useState([
    "skill-3-months",
    "skill-6-months",
    "skill-1-year",
    // "skill-2-years",
  ]);
  const [JobDemandChipIds] = useState([
    "job-3-months",
    "job-6-months",
    "job-1-year",
    // "job-2-years",
  ]);
  const [SelectedSkillOpts, setSelectedSkillOpts] = useState([]);
  const [SelectedPosTitleOpts, setSelectedPosTitleOpts] = useState([]);
  const [SkillsOptions, setSkillsOptions] = useState([]);
  const [PosTitleOptions, setPosTitleOptions] = useState([]);
  const [SkillMonthCount, setSkillMonthCount] = useState(8);
  const [JobMonthCount, setJobMonthCount] = useState(8);
  const [Colors] = useState([
    "#FFA8A8",
    "#DE8C8C",
    "#71D9BB",
    "#C7A3FF",
    "#6DA2F2",
  ]);
  const [SkillChartData, setSkillChartData] = useState();
  const [JobChartData, setJobChartData] = useState();
  const [SkillsIsOpen, setSkillsIsOpen] = useState(true);
  const [JobsIsOpen, setJobsIsOpen] = useState(true);
  const [JobDemandModelType, setJobModelType] = useState("Prophet");
  const [SkillDemandModelType, setSkillModelType] = useState("Prophet");

  useEffect(() => {
    fetchSkillDemandData(8, true, [], "Prophet");
    fetchJobDemandData(8, true, [], "Prophet");
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const fetchSkillDemandData = (Months, IsInitial, Titles, ModelType) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/demand-prediction/skill",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        monthCount: Months,
        titles: Titles,
        type: ModelType,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        // labels which are month names here, selected and pushed respectively to the array
        var labels = [];
        if (Res.data.length > 0) {
          Res.data[0].month.map((Month) => {
            labels.push(Month);
          });
        }
        // creating the datasets which are the numbers related to each index in the Labels array
        var datasets = [];
        Res.data.map((Item, i) => {
          datasets.push({
            label: Item.title,
            data: Item.data,
            backgroundColor: Colors[i],
            borderColor: Colors[i],
          });
        });

        let Data = {
          labels,
          datasets,
        };

        if (!IsInitial && Titles.length === 0) {
          setSelectedSkillOpts([]);
          // fetchSkillsOpts("");
          setSkillChartData({ datasets: [], labels: [] });
        } else {
          // setting the top 5 skill items
          if (IsInitial) {
            let SelectedSkills = [];
            Res.data.map((Item) => {
              SelectedSkills.push({
                id: "skill-" + Item.id,
                title: Item.title,
              });
            });
            setSelectedSkillOpts(SelectedSkills);
            fetchSkillsOpts("", SelectedSkills);
          } else {
            // fetchSkillsOpts("");
          }
          setSkillChartData(Data);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchJobDemandData = (Months, IsInitial, Titles, ModelType) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/demand-prediction/position",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        monthCount: Months,
        titles: Titles,
        type: ModelType,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        // labels which are month names here, selected and pushed respectively to the array
        var labels = [];
        if (Res.data.length > 0) {
          Res.data[0].month.map((Month) => {
            labels.push(Month);
          });
        }
        // creating the datasets which are the numbers related to each index in the Labels array
        var datasets = [];
        Res.data.map((Item, i) => {
          datasets.push({
            label: Item.title,
            data: Item.data,
            backgroundColor: Colors[i],
            borderColor: Colors[i],
          });
        });

        let Data = {
          labels,
          datasets,
        };

        if (!IsInitial && Titles.length === 0) {
          setSelectedPosTitleOpts([]);
          fetchPosTitles(Titles);
          setJobChartData({ datasets: [], labels: [] });
        } else {
          // setting the top 5 items
          let SelectedItems = [];
          Res.data.map((Item, i) => {
            SelectedItems.push({
              id: "postitle-" + i + 2000,
              title: Item.title,
            });
          });
          if (Res.data.length === 0) {
            setSelectedPosTitleOpts([]);
          } else {
            setSelectedPosTitleOpts(SelectedItems);
          }

          fetchPosTitles(SelectedItems);
          setJobChartData(Data);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchPosTitles = (InitialList) => {
    let NameLike = document.getElementById("postitle-seacrh").value;
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/demand-prediction/position-titles?nameLike=" +
        NameLike,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    setSelectedPosTitleOpts(InitialList);

    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Data = [];
        let Names = [];
        InitialList.map((Item) => {
          Names.push(Item.title);
        });
        // Creating the data as {title:"", id: ""}
        Res.data.map((Item, i) => {
          if (!Names.includes(Item)) {
            Data.push({
              id: "postitle-" + i,
              title: Item,
            });
          }
        });
        setPosTitleOptions(Data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleSkillChartChipSelection = (SelectedID, Months) => {
    setSkillMonthCount(Months);

    SkillChipIds.map((Id) => {
      document.getElementById(Id).classList.remove("active-chip");
    });

    document.getElementById(SelectedID).classList.add("active-chip");

    let Titles = [];
    SelectedSkillOpts.map((Item) => {
      Titles.push(Item.title);
    });
    fetchSkillDemandData(Months, false, Titles, SkillDemandModelType);
  };

  const handleJobChartChipSelection = (SelectedID, Months) => {
    setJobMonthCount(Months);

    JobDemandChipIds.map((Id) => {
      document.getElementById(Id).classList.remove("active-chip");
    });

    document.getElementById(SelectedID).classList.add("active-chip");

    let Titles = [];
    SelectedPosTitleOpts.map((Item) => {
      Titles.push(Item.title);
    });
    fetchJobDemandData(Months, false, Titles, JobDemandModelType);
  };

  const fetchSkillsOpts = (NameLike, InitialList) => {
    if (!InitialList) {
      InitialList = SelectedSkillOpts;
    }
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/demand-prediction/skill-titles?nameLike=" +
        NameLike,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Skills = [];
        let SkillNames = [];
        InitialList.map((Item) => {
          SkillNames.push(Item.title);
        });
        Res.data.results.map((Item) => {
          if (!SkillNames.includes(Item.title)) {
            Skills.push({ id: "skill-" + Item.id, title: Item.title });
          }
        });
        setSkillsOptions(Skills);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const updateSkillsOpts = (Selected) => {
    let NonDuplicateArray = Selected.filter(
      (v, i, a) => a.findIndex((v2) => v2.id === v.id) === i
    );
    setSelectedSkillOpts(NonDuplicateArray);

    var RemainingSkills = [];
    [...SkillsOptions].map((SkillItem) => {
      if ([...NonDuplicateArray].indexOf(SkillItem) === -1) {
        RemainingSkills.push(SkillItem);
      }
    });
    setSkillsOptions(RemainingSkills);

    let Titles = [];
    NonDuplicateArray.map((Item) => {
      Titles.push(Item.title);
    });
    fetchSkillsOpts("", NonDuplicateArray);
    fetchSkillDemandData(SkillMonthCount, false, Titles, SkillDemandModelType);
  };
  const updatePosTitleOpts = (Selected) => {
    setSelectedPosTitleOpts(Selected);
    var RemainingSkills = [];
    [...PosTitleOptions].map((SkillItem) => {
      if ([...Selected].indexOf(SkillItem) === -1) {
        RemainingSkills.push(SkillItem);
      }
    });
    setPosTitleOptions(RemainingSkills);

    let Titles = [];
    Selected.map((Item) => {
      Titles.push(Item.title);
    });
    fetchJobDemandData(JobMonthCount, false, Titles, JobDemandModelType);
  };
  const removeSkillsSelectedState = () => {
    SkillsOptions.map((Item) => {
      let Id = Item.id;
      if (document.getElementById(Id + "-option") !== null) {
        document.getElementById(Id + "-option").classList.remove("selected");
      }
    });
  };
  const removePosTitlesSelectedState = () => {
    PosTitleOptions.map((Item) => {
      let Id = Item.id;
      if (document.getElementById(Id + "-option") !== null) {
        document.getElementById(Id + "-option").classList.remove("selected");
      }
    });
  };
  const clearSkills = () => {
    fetchSkillsOpts("", []);
    removeSkillsSelectedState();
    setSelectedSkillOpts([]);
  };

  const clearPosTitles = () => {
    fetchPosTitles([]);
    removePosTitlesSelectedState();
    setSelectedPosTitleOpts([]);
  };

  const switchSkillModels = (RequestedModel) => {
    setSkillModelType(RequestedModel);

    let Titles = [];
    SelectedSkillOpts.map((Item) => {
      Titles.push(Item.title);
    });
    fetchSkillDemandData(SkillMonthCount, true, Titles, RequestedModel);
  };

  const switchJobModels = (RequestedModel) => {
    setJobModelType(RequestedModel);

    let Titles = [];
    SelectedPosTitleOpts.map((Item) => {
      Titles.push(Item.title);
    });
    fetchJobDemandData(JobMonthCount, true, Titles, RequestedModel);
  };

  const shortenText = (Title, LengthLimit) => {
    if (Title.length < LengthLimit) {
      return Title;
    } else {
      let Short = Title.slice(0, LengthLimit - 4) + " ...";
      return (
        <>
          <p className="tooltip-text">{Title}</p>
          {Short}
        </>
      );
    }
  };

  return (
    <div className="dashboard-pages-content predict-dashboard">
      {window.innerWidth <= 450 ? (
        <Collapsible
          open
          onOpening={() => setJobsIsOpen(true)}
          onClosing={() => setJobsIsOpen(false)}
          trigger={
            <section className="mobile-trigger">
              <h1>{translateText("job_demand_prediction")}</h1>
              <i
                className={
                  JobsIsOpen
                    ? "feather-chevron-down icon-transformed"
                    : "feather-chevron-down"
                }
              ></i>
            </section>
          }
        >
          {" "}
          <section className="bg-section">
            <h1 className="bg-title">
              {translateText("job_demand_prediction")}
            </h1>

            <div className="line-chart-wrapper">
              {JobChartData ? <LineChart Data={JobChartData} /> : null}
              <section className="chart-time-filters">
                <span
                  className="time-chip"
                  id="job-3-months"
                  onClick={() => handleJobChartChipSelection("job-3-months", 3)}
                >
                  3 {translateText("rejected_application_details_modal_2")}
                </span>
                <span
                  className="time-chip"
                  id="job-6-months"
                  onClick={() => handleJobChartChipSelection("job-6-months", 6)}
                >
                  6 {translateText("rejected_application_details_modal_2")}
                </span>
                <span
                  className="time-chip active-chip"
                  id="job-1-year"
                  onClick={() => handleJobChartChipSelection("job-1-year", 8)}
                >
                  8 {translateText("rejected_application_details_modal_2")}
                </span>
              </section>
            </div>
            <div className="chart-info">
              <SearchSelect
                Label={translateText("select_job_titles")}
                SearchLabel={translateText("search")}
                ToggleSearch={() => fetchPosTitles(SelectedPosTitleOpts)}
                Options={PosTitleOptions}
                SelectedItems={SelectedPosTitleOpts}
                UpdateList={(SelectedList) => updatePosTitleOpts(SelectedList)}
                ClearInput={() => clearPosTitles()}
                LangData={props.LangData}
                RemoveSelectedState={() => removePosTitlesSelectedState()}
                Id="postitle-seacrh"
              />
              {/* <section className="model-switches">
                <span
                  onClick={() => switchJobModels("Prophet")}
                  className={
                    JobDemandModelType === "Prophet"
                      ? "model-btn active-btn"
                      : "model-btn"
                  }
                >
                  Prophet
                </span>
                <span
                  onClick={() => switchJobModels("XGBoost")}
                  className={
                    JobDemandModelType === "XGBoost"
                      ? "model-btn active-btn"
                      : "model-btn"
                  }
                >
                  XGBoost
                </span>
              </section> */}
              {JobChartData ? (
                <section className="lables-wrapper">
                  {JobChartData.datasets.map((Job) => (
                    <div className="info-row">
                      <span
                        className="sm-circle"
                        style={{
                          backgroundColor: Job.backgroundColor,
                        }}
                      ></span>
                      <p className="item-title">{shortenText(Job.label, 25)}</p>
                    </div>
                  ))}
                </section>
              ) : null}
            </div>
          </section>
        </Collapsible>
      ) : (
        <section className="bg-section">
          <h1 className="bg-title">{translateText("job_demand_prediction")}</h1>
          {/* <section className="model-switches">
            <span
              onClick={() => switchJobModels("Prophet")}
              className={
                JobDemandModelType === "Prophet"
                  ? "model-btn active-btn"
                  : "model-btn"
              }
            >
              Prophet
            </span>
            <span
              onClick={() => switchJobModels("XGBoost")}
              className={
                JobDemandModelType === "XGBoost"
                  ? "model-btn active-btn"
                  : "model-btn"
              }
            >
              XGBoost
            </span>
          </section> */}
          <div className="line-chart-wrapper">
            {JobChartData ? <LineChart Data={JobChartData} /> : null}
            <section className="chart-time-filters">
              <span
                className="time-chip"
                id="job-3-months"
                onClick={() => handleJobChartChipSelection("job-3-months", 3)}
              >
                3 {translateText("rejected_application_details_modal_2")}
              </span>
              <span
                className="time-chip"
                id="job-6-months"
                onClick={() => handleJobChartChipSelection("job-6-months", 6)}
              >
                6 {translateText("rejected_application_details_modal_2")}
              </span>
              <span
                className="time-chip active-chip"
                id="job-1-year"
                onClick={() => handleJobChartChipSelection("job-1-year", 8)}
              >
                8 {translateText("rejected_application_details_modal_2")}
              </span>
            </section>
          </div>
          <div className="chart-info">
            <SearchSelect
              Label={translateText("select_job_titles")}
              SearchLabel={translateText("search")}
              ToggleSearch={() => fetchPosTitles(SelectedPosTitleOpts)}
              Options={PosTitleOptions}
              SelectedItems={SelectedPosTitleOpts}
              UpdateList={(SelectedList) => updatePosTitleOpts(SelectedList)}
              ClearInput={() => clearPosTitles()}
              LangData={props.LangData}
              RemoveSelectedState={() => removePosTitlesSelectedState()}
              Id="postitle-seacrh"
            />
            {JobChartData ? (
              <section className="lables-wrapper">
                {JobChartData.datasets.map((Job) => (
                  <div className="info-row">
                    <span
                      className="sm-circle"
                      style={{
                        backgroundColor: Job.backgroundColor,
                      }}
                    ></span>
                    <p className="item-title">{shortenText(Job.label, 25)}</p>
                  </div>
                ))}
              </section>
            ) : null}
          </div>
        </section>
      )}
      {window.innerWidth <= 450 ? (
        <Collapsible
          onOpening={() => setSkillsIsOpen(true)}
          onClosing={() => setSkillsIsOpen(false)}
          open
          trigger={
            <section className="mobile-trigger">
              <h1>{translateText("skill_demand_prediction")}</h1>
              <i
                className={
                  SkillsIsOpen
                    ? "feather-chevron-down icon-transformed"
                    : "feather-chevron-down"
                }
              ></i>
            </section>
          }
        >
          <section className="bg-section">
            <h1 className="bg-title">
              {translateText("skill_demand_prediction")}
            </h1>

            <div className="line-chart-wrapper">
              {SkillChartData ? <LineChart Data={SkillChartData} /> : null}
              <section className="chart-time-filters">
                <span
                  className="time-chip"
                  id="skill-3-months"
                  onClick={() =>
                    handleSkillChartChipSelection("skill-3-months", 3)
                  }
                >
                  3 {translateText("rejected_application_details_modal_2")}
                </span>
                <span
                  className="time-chip"
                  id="skill-6-months"
                  onClick={() =>
                    handleSkillChartChipSelection("skill-6-months", 6)
                  }
                >
                  6 {translateText("rejected_application_details_modal_2")}
                </span>
                <span
                  className="time-chip active-chip"
                  id="skill-1-year"
                  onClick={() =>
                    handleSkillChartChipSelection("skill-1-year", 8)
                  }
                >
                  8 {translateText("rejected_application_details_modal_2")}
                </span>
                {/* <span
                  className="time-chip"
                  id="skill-2-years"
                  onClick={() =>
                    handleSkillChartChipSelection("skill-2-years", 24)
                  }
                >
                  2 {translateText("years")}
                </span> */}
              </section>
            </div>
            <div className="chart-info">
              <SearchSelect
                Label={translateText("select_skills")}
                SearchLabel={translateText("search_skills")}
                ToggleSearch={(NameLike) => fetchSkillsOpts(NameLike)}
                Options={SkillsOptions}
                SelectedItems={SelectedSkillOpts}
                UpdateList={(SelectedList) => updateSkillsOpts(SelectedList)}
                ClearInput={() => clearSkills()}
                LangData={props.LangData}
                RemoveSelectedState={() => removeSkillsSelectedState()}
                Id="search-skills"
              />
              {/* <section className="model-switches">
                <span
                  onClick={() => switchSkillModels("Prophet")}
                  className={
                    SkillDemandModelType === "Prophet"
                      ? "model-btn active-btn"
                      : "model-btn"
                  }
                >
                  Prophet
                </span>
                <span
                  onClick={() => switchSkillModels("XGBoost")}
                  className={
                    SkillDemandModelType === "XGBoost"
                      ? "model-btn active-btn"
                      : "model-btn"
                  }
                >
                  XGBoost
                </span>
              </section> */}
              {SkillChartData ? (
                <section className="lables-wrapper">
                  {SkillChartData.datasets.map((Skill) => (
                    <div className="info-row">
                      <span
                        className="sm-circle"
                        style={{
                          backgroundColor: Skill.backgroundColor,
                        }}
                      ></span>
                      <p className="item-title">
                        {shortenText(Skill.label, 25)}
                      </p>
                    </div>
                  ))}
                </section>
              ) : null}
            </div>
          </section>
        </Collapsible>
      ) : (
        <section className="bg-section">
          <h1 className="bg-title">
            {translateText("skill_demand_prediction")}
          </h1>
          {/* <section className="model-switches">
            <span
              onClick={() => switchSkillModels("Prophet")}
              className={
                SkillDemandModelType === "Prophet"
                  ? "model-btn active-btn"
                  : "model-btn"
              }
            >
              Prophet
            </span>
            <span
              onClick={() => switchSkillModels("XGBoost")}
              className={
                SkillDemandModelType === "XGBoost"
                  ? "model-btn active-btn"
                  : "model-btn"
              }
            >
              XGBoost
            </span>
          </section> */}
          <div className="line-chart-wrapper">
            {SkillChartData ? <LineChart Data={SkillChartData} /> : null}
            <section className="chart-time-filters">
              <span
                className="time-chip"
                id="skill-3-months"
                onClick={() =>
                  handleSkillChartChipSelection("skill-3-months", 3)
                }
              >
                3 {translateText("rejected_application_details_modal_2")}
              </span>
              <span
                className="time-chip"
                id="skill-6-months"
                onClick={() =>
                  handleSkillChartChipSelection("skill-6-months", 6)
                }
              >
                6 {translateText("rejected_application_details_modal_2")}
              </span>
              <span
                className="time-chip active-chip"
                id="skill-1-year"
                onClick={() => handleSkillChartChipSelection("skill-1-year", 8)}
              >
                8 {translateText("rejected_application_details_modal_2")}
              </span>
            </section>
          </div>
          <div className="chart-info">
            <SearchSelect
              Label={translateText("select_skills")}
              SearchLabel={translateText("search_skills")}
              ToggleSearch={(NameLike) => fetchSkillsOpts(NameLike)}
              Options={SkillsOptions}
              SelectedItems={SelectedSkillOpts}
              UpdateList={(SelectedList) => updateSkillsOpts(SelectedList)}
              ClearInput={() => clearSkills()}
              LangData={props.LangData}
              RemoveSelectedState={() => removeSkillsSelectedState()}
              Id="search-skills"
            />
            {SkillChartData ? (
              <section className="lables-wrapper">
                {SkillChartData.datasets.map((Skill) => (
                  <div className="info-row">
                    <span
                      className="sm-circle"
                      style={{
                        backgroundColor: Skill.backgroundColor,
                      }}
                    ></span>
                    <p className="item-title">{shortenText(Skill.label, 25)}</p>
                  </div>
                ))}
              </section>
            ) : null}
          </div>
        </section>
      )}
    </div>
  );
};

export default PredictDashboard;
